import { useEffect } from 'react';

export function useBodyClass(className: string | undefined) {
  useEffect(() => {
    if (!className) {
      return;
    }

    document.body.classList.add(className);

    // eslint-disable-next-line consistent-return
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);
}
